<template>
  <VTooltip
    :disabled="props.disabled"
    :location="props.location"
    :offset="props.offset"
    :max-width="props.maxWidth"
    data-cy="wrapper__easy-tooltip"
    :z-index="props.zIndex"
  >
    <template
      v-if="slots['activator']"
      #activator="{ props: activatorProps }"
    >
      <slot
        :activator-props="activatorProps"
        name="activator"
      />
    </template>

    <span
      v-if="props.text"
      v-dompurify-html="props.text"
      data-cy="text__easy-tooltip"
    />
    <slot v-else />
  </VTooltip>
</template>

<script setup lang="ts">
import { VuetifyLocations } from "../types";
import { useSlots } from "vue";
import { VueSlots } from "@/src/shared/types/slot";

interface Props {
  disabled?: boolean;
  location?: VuetifyLocations;
  maxWidth?: number;
  offset?: number;
  text?: string;
  // use for ant dropdowns
  zIndex?: number;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  location: VuetifyLocations.Top,
  maxWidth: undefined,
  offset: undefined,
  text: undefined,
  zIndex: undefined,
});

const slots = useSlots() as VueSlots<["activator"]>;
</script>
